import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatScheduledTime',
})
export class FormatScheduledTimePipe implements PipeTransform {
  transform(value: string, resolved: string | undefined): string {
    const startedAt = new Date(value);
    const resolvedAt = resolved ? new Date(resolved) : undefined;

    const formatTime = (date: Date): string => {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    };

    let startString = formatTime(startedAt);
    if (resolvedAt) {
      startString += ' - ' + formatTime(resolvedAt);
    }
    return startString;
  }
}
